import { render } from "./FundingManagement.vue?vue&type=template&id=3deaecea"
import script from "./FundingManagement.vue?vue&type=script&lang=js"
export * from "./FundingManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__